export const AppState = {
  ABIERTO: "0",
  CERRADO: "1",
  BY_PASS: "2",
  MANTENIMIENTO: "3",
  BY_PASS_SOPORTE: "4",
} as const;

export type AppStateType = typeof AppState[keyof typeof AppState];